export default (value) => {
  window.localStorage.setItem('language', value)
  window.AppSettings.language = value
}
